import { createRemoteStore } from '@move-frontend/utils';
import { ILoaderDeleteVehicle } from '../use-cases/deleteVehicleLoader';
import { DeleteVehicleRequest } from '../../../../shared/api/gateway/types/vehicle';

export type DeleteVehicleStore = ReturnType<typeof createDeleteVehicleStore>;

export const createDeleteVehicleStore = (deleteVehicle: ILoaderDeleteVehicle) =>
	createRemoteStore<DeleteVehicleRequest, void>({
		loader: deleteVehicle,
	});
